import React from 'react';
import { NavLink } from 'react-router-dom'

const RankingsSelector = props => {

  const {
    rankings
  } = props

  return(
    <div className='ranking-selector'>
      {rankings.map((ranking) => (
        <NavLink
          activeClassName="ranking-selector-item-active"
          className="ranking-selector-item"
          key={"ranking-selector-" + ranking.id}
          to={`/rankings/${ranking.id}`}>
            {ranking.name}
        </NavLink>
      ))}
    </div>
  )
}

export default RankingsSelector